import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';

import AirbnbAccountsPage from './AirbnbAccountsPage';

const exports = {
    Page: AirbnbAccountsPage,
    Icon: HomeWorkOutlinedIcon,
};

export default exports;
